import React, { useEffect, useState } from 'react';
import Switch from "react-switch";
import { Form, FormFeedback, Input } from 'reactstrap';
import { Offsymbol, OnSymbol } from '../../../constants/holcim';
import { BaseCustomModal, BaseCustomButton, BaseSelectComponent, GradientDecorationLine } from '../../../shared';

// Formik formikData
import { useFormik } from "formik";
import * as Yup from "yup";

export const LabEssayRegisterModal = ({ setShowModal, showModal, modalHeader, modalClose, modalRespInfo, isUpdate, rowInfo, labAreas, norms }) => {

    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
        console.log('rowInfo', rowInfo);
    }, [showModal])

    const formikData = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            name: isUpdate ? rowInfo.name : '',
            laboratoryArea: isUpdate ? rowInfo.laboratoryArea.id : '',
            norm: isUpdate ? rowInfo.norm.id : '',
            method: isUpdate ? rowInfo.method : '',
            description: isUpdate ? rowInfo.description : '',
            materialCost: isUpdate ? rowInfo.materialCost : '',
            thirdCost: isUpdate ? rowInfo.thirdCost : '',
            workforceCost: isUpdate ? rowInfo.workforceCost : '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Ingrese el nombre del tipo de laboratorio"),
            laboratoryArea: Yup.string().required("Seleccione el  área de laboratorio"),
            norm: Yup.string().required("Seleccione una norma"),
            method: Yup.string().required("Ingrese método de ensayo"),
            description: Yup.string().required("Ingrese descripción de ensayo"),
            materialCost: Yup.number().min(0, 'Costo debe ser mayor o igual a $0').required("Ingrese costo de material"),
            thirdCost: Yup.number().min(0, 'Costo debe ser mayor o igual a $0').required("Ingrese costo de terceros"),
            workforceCost: Yup.number().min(0, 'Costo debe ser mayor o igual a $0').required("Ingrese costo de mano de obra"),
        }),
        onSubmit: (values, { resetForm }) => {
            const updToSend = {
                ...values,
                totalCost: (Number(values.materialCost) + Number(values.workforceCost))
            }
            modalRespInfo(updToSend, active)
            resetForm()
            setShowModal(false)
        }
    });

    const onClosed = () => {
        setShowModal(!showModal);
        formikData.resetForm()
        modalClose()
    }

    const handleSelectChange = (field, selectedValue) => formikData.setFieldValue(field, selectedValue);

    const children_form = (
        <>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Clases de Material</h4>
            <GradientDecorationLine />
            <Form
                className="form-horizontal mt-3 mb-1"
                onSubmit={(e) => {
                    e.preventDefault();
                    formikData.handleSubmit();
                    return false;
                }}
            >
                <div className="mb-3 px-5">
                    <label className='text-primary'>Nombre de Ensayo</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Nombre de Ensayo"
                        type="text"
                        onChange={formikData.handleChange}
                        onBlur={formikData.handleBlur}
                        value={formikData.values.name || ""}
                        invalid={
                            formikData.touched.name && formikData.errors.name ? true : false
                        }
                    />
                    {formikData.touched.name && formikData.errors.name ? (
                        <FormFeedback type="invalid">{formikData.errors.name}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Área de Laboratorio</label>
                    <BaseSelectComponent
                        options={labAreas.map(dir => ({ value: dir.id, label: dir.name }))}
                        value={formikData.values.laboratoryArea}
                        onChange={(value) => handleSelectChange("laboratoryArea", value)}
                        placeholder="Seleccione Área de Laboratorio"
                        error="Seleccione Área de Laboratorio"
                        touched={formikData.errors.laboratoryArea && formikData.touched.laboratoryArea}
                        status={formikData.errors.laboratoryArea && formikData.touched.laboratoryArea ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Normas</label>
                    <BaseSelectComponent
                        options={norms.map(dir => ({ value: dir.id, label: dir.name }))}
                        value={formikData.values.norm}
                        onChange={(value) => handleSelectChange("norm", value)}
                        placeholder="Seleccione Norma"
                        error="Seleccione Norma"
                        touched={formikData.errors.norm && formikData.touched.norm}
                        status={formikData.errors.norm && formikData.touched.norm ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Método de ensayo</label>
                    <Input
                        name="method"
                        className="form-control text-primary"
                        placeholder="Método de ensayo"
                        type="text"
                        onChange={formikData.handleChange}
                        onBlur={formikData.handleBlur}
                        value={formikData.values.method || ""}
                        invalid={
                            formikData.touched.method && formikData.errors.method ? true : false
                        }
                    />
                    {formikData.touched.method && formikData.errors.method ? (
                        <FormFeedback type="invalid">{formikData.errors.method}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Descripción ensayo</label>
                    <Input
                        name="description"
                        className="form-control text-primary"
                        placeholder="Descripción de ensayo"
                        type="text"
                        onChange={formikData.handleChange}
                        onBlur={formikData.handleBlur}
                        value={formikData.values.description || ""}
                        invalid={
                            formikData.touched.description && formikData.errors.description ? true : false
                        }
                    />
                    {formikData.touched.description && formikData.errors.description ? (
                        <FormFeedback type="invalid">{formikData.errors.description}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Costo Material</label>
                    <Input
                        name="materialCost"
                        className="form-control text-primary"
                        placeholder="Costo Material"
                        type="number"
                        onChange={formikData.handleChange}
                        onBlur={formikData.handleBlur}
                        value={formikData.values.materialCost || ""}
                        invalid={
                            formikData.touched.materialCost && formikData.errors.materialCost ? true : false
                        }
                        onFocus={(e) => e.target.select()}
                    />
                    {formikData.touched.materialCost && formikData.errors.materialCost ? (
                        <FormFeedback type="invalid">{formikData.errors.materialCost}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Costo Terceros</label>
                    <Input
                        name="thirdCost"
                        className="form-control text-primary"
                        placeholder="Costo Terceros"
                        type="number"
                        onChange={formikData.handleChange}
                        onBlur={formikData.handleBlur}
                        value={formikData.values.thirdCost || ""}
                        invalid={
                            formikData.touched.thirdCost && formikData.errors.thirdCost ? true : false
                        }
                        onFocus={(e) => e.target.select()}
                    />
                    {formikData.touched.thirdCost && formikData.errors.thirdCost ? (
                        <FormFeedback type="invalid">{formikData.errors.thirdCost}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Costo de Mano de Obra</label>
                    <Input
                        name="workforceCost"
                        className="form-control text-primary"
                        placeholder="Costo de Mano de Obra"
                        type="number"
                        onChange={formikData.handleChange}
                        onBlur={formikData.handleBlur}
                        value={formikData.values.workforceCost || ""}
                        invalid={
                            formikData.touched.workforceCost && formikData.errors.workforceCost ? true : false
                        }
                        onFocus={(e) => e.target.select()}
                    />
                    {formikData.touched.workforceCost && formikData.errors.workforceCost ? (
                        <FormFeedback type="invalid">{formikData.errors.workforceCost}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Costo Total</label>
                    <Input
                        disabled={true}
                        className="form-control text-primary"
                        placeholder="Costo Total"
                        type="number"
                        onChange={formikData.handleChange}
                        onBlur={formikData.handleBlur}
                        value={(Number(formikData.values.materialCost) + Number(formikData.values.workforceCost)) || 0}
                    />
                </div>
                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => { setActive(!active) }}
                        checked={active}
                    />
                </div>
                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-4'
                            onClick={formikData.handleSubmit}
                            label="Guardar"
                            icon="mdi mdi-content-save me-1"
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={() => { onClosed() }}
                            label="Cancelar"
                            icon="mdi mdi-close-circle-outline me-1"
                        />
                    </div>
                </div>
            </Form>
        </>
    );

    return (
        <>
            <BaseCustomModal
                isModalOpen={showModal}
                handleCancel={onClosed}
                modalHeader={modalHeader}
                children={children_form}
                footer={null}
                width={800}
            />
        </>
    )

}